import {
  type SessionIngestionSummary,
  type SessionRecord,
  tracksCompletion,
} from "@/shared/domain/sessions";

import {
  completeSessionBadge,
  type SessionBadge,
} from "./sessionIngestionBadge";

/**
 * A session's status as a list row shows it. A complete session shows what
 * its ingestion summary says, the same badge as its page; until the summary
 * loads it is plain "Complete", never green. Null for a session nobody opted
 * into completion (see {@link tracksCompletion}).
 */
export function sessionListStatus(
  session: Pick<SessionRecord, "status" | "completed_at" | "completion_policy">,
  summary: SessionIngestionSummary | undefined,
): SessionBadge | null {
  if (!tracksCompletion(session)) {
    return null;
  }
  if (session.status === "in_progress") {
    return { label: "In progress", variant: "info" };
  }
  if (summary === undefined || summary.state === "in_progress") {
    return { label: "Complete", variant: "secondary" };
  }
  return completeSessionBadge(summary);
}
